// @ts-nocheck
import ReactOnRails from "react-on-rails";
import { MoveProjectFooter } from "../../components/common/ProjectFooter/MoveProjectFooter";
import { HeldWorkflowMenu } from "../../components/common/ProjectFooter/HeldWorkflowMenu";
import { WorkflowTemplateFooter } from "../../components/common/ProjectFooter/WorkflowTemplateFooter";
import { LoadBootBtn } from "../../components/common/LoadBtn/LoadBootBtn";
import AddSectionButton from "../../components/templates/Sidebar/AddSectionButton";
import EditSectionButton from "../../components/templates/Sidebar/EditSectionButton";
import { SectionIcon } from "../../components/templates/section/SectionIcon";

ReactOnRails.register({
  MoveProjectFooter,
  HeldWorkflowMenu,
  WorkflowTemplateFooter,
  LoadBootBtn,
  AddSectionButton,
  EditSectionButton,
  SectionIcon,
});
